import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Joki } from "@/components/Joki";

/**
 * Splash écran de chargement entre les pages.
 * S'affiche brièvement à chaque changement de route (~600ms).
 */
export const PageLoader = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 650);
    return () => clearTimeout(t);
  }, [location.pathname]);

  return (
    <div
      data-testid="page-loader"
      aria-hidden={!visible}
      className={`pointer-events-none fixed inset-0 z-[100] flex items-center justify-center bg-brand-cream transition-opacity duration-500 ${
        visible ? "opacity-100" : "opacity-0"
      }`}
    >
      <div className="flex flex-col items-center gap-5">
        <div className="relative">
          <Joki pose="wink" size={140} float />
          <div className="absolute -inset-6 -z-10 animate-pulse rounded-full bg-brand-sand/40 blur-2xl" />
        </div>
        <div className="flex items-center gap-1.5">
          <span className="h-2 w-2 animate-bounce rounded-full bg-brand-sand-dark [animation-delay:-0.3s]" />
          <span className="h-2 w-2 animate-bounce rounded-full bg-brand-sand [animation-delay:-0.15s]" />
          <span className="h-2 w-2 animate-bounce rounded-full bg-brand-sage" />
        </div>
        <p className="font-heading text-sm font-semibold tracking-wider text-brand-slate-dark/70">
          Joki prépare la page…
        </p>
      </div>
    </div>
  );
};
